import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchBlogPosts } from "../lib/api";

export const Route = createFileRoute("/blog")({
  component: Blog,
});

function Blog() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["blog"],
    queryFn: fetchBlogPosts,
  });

  return (
    <>
      <p className="frame-label">
        frame <b>#4</b> — blog()
      </p>
      <div className="sec-head">
        <span className="addr">0x0004</span>
        <h2>compiled_artifacts[]</h2>
      </div>

      <div className="comment-block">
        <span>/**</span>
        <span> * each post below compiled from source (.mdx) → static HTML</span>
        <span> * sorted by build timestamp, descending</span>
        <span> */</span>
      </div>

      {isLoading && <p className="section-sub">// loading...</p>}
      {isError && <p className="section-sub">// could not reach the api</p>}

      {(data ?? []).map((post) => (
        <Link key={post.slug} className="post-row" to="/blog/$slug" params={{ slug: post.slug }}>
          <span className="date">
            {post.publishedAt ? post.publishedAt.slice(0, 10) : "unpublished"}
          </span>
          <div>
            <div className="title">{post.title}</div>
            {post.tags.length > 0 && (
              <div className="post-tag">// tags: {post.tags.join(", ")}</div>
            )}
          </div>
          <span className="meta">{post.readTime ? `${post.readTime} min read` : ""}</span>
        </Link>
      ))}

      <Link to="/about" hash="contact" className="cta primary">
        step into contact()
      </Link>
    </>
  );
}
